<template>
  <div class="d-flex agent-assistant-message mb-3">
    <v-avatar size="28" color="primary" class="mr-2 mt-1">
      <app-icon size="16" color="white">wand_stars</app-icon>
    </v-avatar>
    <div class="agent-bubble">
      <div v-if="pending" class="text-medium-emphasis">Pensando…</div>
      <div v-else-if="error" class="error--text d-flex align-center">
        <app-icon size="16" class="mr-1">warning</app-icon>
        {{ text }}
      </div>
      <div v-else-if="text" v-html="renderedText"></div>
    </div>
  </div>
</template>

<script>
// html: false — the model's own text is never trusted with raw HTML.
import markdownit from 'markdown-it'

const md = markdownit({ html: false, linkify: true })

export default {
  name: 'AgentAssistantMessage',
  props: {
    text: {
      type: String,
      default: null,
    },
    pending: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    renderedText() {
      return md.render(this.text || '')
    },
  },
}
</script>

<style lang="scss" scoped>
.agent-assistant-message {
  font-size: 14px;
}

.agent-bubble {
  background: #f5f5f7;
  border-radius: 12px;
  padding: 10px 14px;
  max-width: 90%;
}

.agent-bubble ::v-deep(p) {
  margin: 0 0 8px;
}

.agent-bubble ::v-deep(p:last-child) {
  margin-bottom: 0;
}

.agent-bubble ::v-deep(li) {
  margin-left: 16px;
}
</style>
